import React from "react";
import { Database, GitCompare, Camera, Activity, BarChart3, TrendingUp } from "lucide-react";
import Reveal from "../common/Reveal";

const ANALYSIS_SERVICES = [
  {
    icon: Database,
    title: "생산·품질·설비 데이터 통합 분석",
    desc: "다양한 데이터를 표준화하여 통합 분석 및 인사이트 제공",
  },
  {
    icon: GitCompare,
    title: "공정조건-품질 상관관계 분석",
    desc: "공정변수와 품질결과 간 상관관계 및 영향도 분석",
  },
  {
    icon: Camera,
    title: "AI 비전검사 & 이미지 분석",
    desc: "이미지 기반 불량 자동 판정 및 불량 유형 분류, 이력관리",
  },
  {
    icon: Activity,
    title: "통계 기반 이상징후 감지",
    desc: "설비 센서 데이터의 이상 패턴 감지 및 알람 제공",
  },
  {
    icon: BarChart3,
    title: "불량 패턴 및 원인분석",
    desc: "불량 유형별 발생 패턴과 주요 영향변수 분석",
  },
  {
    icon: TrendingUp,
    title: "AI 품질예측 및 조건 추천",
    desc: "머신러닝 기반 품질 예측 및 최적 공정조건 추천 (고도화 단계)",
  },
];

const AIServices = () => {
  return (
    <section className="py-16">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
        {/* 텍스트 영역 */}
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-wide text-accent-600">
            AI 제조지능 서비스
          </span>
          <h2 className="mt-3 break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
            MT-NOVA AI 분석 엔진
          </h2>
          <p className="mt-5 break-keep text-base leading-relaxed text-gray-600">
            생산·품질·설비·검사 데이터를 통합 분석하여 불량 발생 요인과
            설비 이상징후, 공정변수 간 연관성을 파악합니다. 초기에는
            룰·통계 기반 분석을 적용하고, 데이터 축적 수준에 따라 머신러닝
            기반 품질예측과 공정조건 추천으로 고도화합니다.
          </p>
        </Reveal>

        {/* 카드 그리드 */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {ANALYSIS_SERVICES.map(({ icon: Icon, title, desc }, index) => (
            <Reveal
              key={title}
              delay={index * 70}
              direction="left"
              className="h-full rounded-lg border-t-4 border-primary-800 bg-primary-50/60 p-5 transition-all duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-lg"
            >
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800">
                <Icon className="h-5 w-5 text-white" strokeWidth={2} />
              </div>
              <h3 className="mt-3 break-keep text-sm font-bold text-primary-900">
                {title}
              </h3>
              <p className="mt-1.5 break-keep text-xs leading-relaxed text-gray-600">
                {desc}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AIServices;
